import FlexLayout from '@components/FlexLayout/index.jsx'
import {data} from './data.js'

export const NativeAppDevelopmentServicesOffer = ()=>{
    return(
        <FlexLayout  
  heading={data.heading}
  text={data.text}
  list={data.list}
  img={data.img}
  alt = {data.altText}
  reverse={true}
/>
    )
} 